export const converterParaNumero = (str, decimalPlaces = 3) => {
    const numero = parseFloat(
        str
            .replace(/[^\d,.-]/g, '') // Remove caracteres não numéricos, exceto `,.-`
            .replace(/\./g, '')        // Remove separador de milhar
            .replace(',', '.')         // Converte vírgula para ponto decimal
    );

    return isNaN(numero) ? null : parseFloat(numero.toFixed(decimalPlaces));
};
